module.exports = __webpack_public_path__ + "static/sip calls to web-a427a4fec34e04e9b5352d62bb414ca0.png";